import { render, staticRenderFns } from "./KPCUDash.vue?vue&type=template&id=987a15f6"
import script from "./KPCUDash.vue?vue&type=script&lang=js"
export * from "./KPCUDash.vue?vue&type=script&lang=js"
import style0 from "./KPCUDash.vue?vue&type=style&index=0&id=987a15f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports